class GeneralHelper {
    /**
     * alternative to lodash throttle
     * @param func
     * @param timeFrame
     * @returns {(function(...[*]): void)|*}
     */
    static throttle(func, timeFrame) {
        let lastTime = 0;
        return (...args) => {
            const now = new Date();
            if (now - lastTime >= timeFrame) {
                func(...args);
                lastTime = now;
            }
        };
    }

    /**
     * return height of page-header and 0 if no page-header exists
     * @returns {number|number}
     */
    static getPageHeaderHeight() {
        const header = document.querySelector('.page-header');

        return header ? header.getBoundingClientRect().height : 0;
    }
}

export default GeneralHelper;
